import Ath from './images/ath.png'
import Cookies from './images/cookies.png'
import Jack from './images/jack_coke.png'

export const VideoData = [
  {
    id: '1',
    title: 'Authentic Tea House from Slow Brew to Slow Down',
    img: Ath,
    videoUrl:
      'https://facade-api-tccc-dev-stage.playground-stage.coke.com/api/file-manager/v1/tenants/571f9aa5-bb8b-4f9f-8835-23e74b64e050/files/b3ad3505-54d1-4139-ad70-33913983f178/public-download',
    event: 'pg_act_innovation_oursuccesses_viewcarrousel3',
  },
  {
    id: '2',
    title: 'Jack and Coke',
    img: Jack,
    videoUrl:
      'https://facade-api-tccc-dev-stage.playground-stage.coke.com/api/file-manager/v1/tenants/571f9aa5-bb8b-4f9f-8835-23e74b64e050/files/2c22f49f-5dee-4c0c-b17a-01e3941818da/public-download',
    event: 'pg_act_innovation_oursuccesses_viewcarrousel1',
  },
  {
    id: '3',
    title: 'Nutriboost Cookies & Cream',
    img: Cookies,
    videoUrl:
      'https://facade-api-tccc-dev-stage.playground-stage.coke.com/api/file-manager/v1/tenants/571f9aa5-bb8b-4f9f-8835-23e74b64e050/files/73bee0d1-8c85-4ba9-8174-7327f69ffb71/public-download',
    event: 'pg_act_innovation_oursuccesses_viewcarrousel2',
  },
]
